import { Tariff } from '@enmon/commons';
import { Col, Row, Typography } from 'antd';
import { ObisSelect } from 'components/Select/Obis';
import { TariffSelect } from 'components/Select/Tariff';
import { VFC } from 'react';
import { useIntl } from 'react-intl';
import { ObisType } from 'routes/inventorize_meter/types';
import { useStore } from 'routes/inventorize_meter/useStore';
import { getObisTranslation } from 'utils/getObisTranslation';
import { REGISTER_MEDIUM_BY_COMMODITY_MAP } from 'utils/register-medium-by-commodity';
import { ReadingStepRegister } from './slice';

interface FullObisProps {
  value?: ReadingStepRegister['fullObis'];
  onChange?: (value: ReadingStepRegister['fullObis']) => void;
}

export const FullObis: VFC<FullObisProps> = ({ value, onChange }) => {
  const intl = useIntl();

  const { commodity } = useStore();

  const handleChange = (updatedPart: Partial<ReadingStepRegister['fullObis']>) => {
    onChange?.({ ...value, ...updatedPart });
  };

  return (
    <Row align="middle" gutter={8} justify="start">
      <Col span={6}>
        <ObisSelect
          commodity={commodity ?? null}
          value={value?.obis}
          onChange={(updatedObis: ObisType) => handleChange({ obis: updatedObis })}
        />
      </Col>
      <Col span={4}>
        <TariffSelect
          value={value?.tariff ?? Tariff.Zero}
          onChange={(updatedTariff: Tariff) => handleChange({ tariff: updatedTariff })}
        />
      </Col>

      <Col lg={14} xs={24}>
        <Typography.Text style={{ minWidth: '60px' }} type="secondary">
          {commodity && value?.obis
            ? getObisTranslation(intl, { medium: REGISTER_MEDIUM_BY_COMMODITY_MAP[commodity], obis: value.obis })
            : '-'}
        </Typography.Text>
      </Col>
    </Row>
  );
};
